
import {Component, Mixins, Prop, Vue, Watch} from "vue-property-decorator";
import YargiTuruPicker from "@/components/pickers/YargiTuruPicker.vue";
import ObjectInputMixin from "@/mixins/ObjectInputMixin.vue";
import {TaskDurum} from "@/plugins/uyap-plugin/enum/TaskDurum";
import ListelemeTuruPicker from "@/components/pickers/ListelemeTuruPicker.vue";
import Dates from "@/components/inputs/Dates.vue";
import * as XLSX from 'xlsx';
import {ProgramPaths} from "@/enum/ProgramPaths";
import {IcraDairesiEntity} from "@/entity/IcraDairesiEntity";
import {AvukatIcraDosyalariTalep} from "@/plugins/uyap-plugin/uyap/AvukatIcraDosyalari";
import {IAvukatDosya, MahkemeBirimleriRow} from "@/plugins/uyap-plugin/uyap/CommonInterfaces";
import DosyaFiltrelemeCard, {ListelemeTuru} from "@/components/eicrapro/DosyaFiltrelemeCard.vue";
import ExcelYuklemeCard from "@/components/eicrapro/ExcelYuklemeCard.vue";
import DetayliAramaPanel from "@/components/eicrapro/DetayliAramaPanel.vue";

@Component({
  computed: {
    ListelemeTuru() {
      return ListelemeTuru
    }
  },
  components: {DetayliAramaPanel, ExcelYuklemeCard, DosyaFiltrelemeCard, Dates, ListelemeTuruPicker, YargiTuruPicker}
})

export default class GenelIslemFormWizard extends Mixins(ObjectInputMixin) {
  @Prop({default: ["Listelenecek Takipler", "Takipleri Seç", "İşlemler", "İşlemler Sıraya Alındı"]}) stepperHeaders!: Array<string>;
  @Prop() showSuccessCloseButton!: string | boolean;
  @Prop() hideNextButton!: string | boolean;
  @Prop({default: false}) onFly!: boolean;
  @Prop({default: 'Yeni işlem için'}) successMessage!: string;
  @Prop({default: false}) showSecilenTakiplerExcelExport!: boolean;

  activeStep: number = 1;
  tablodaAra = '';
  takipSecilmediError = false;
  localValue: GenelIslemEntity = new GenelIslemEntity();
  taskDurum = TaskDurum;
  uyapTakipLoadStatus = {
    loading: false,
    error: false,
    errorMessage: ''
  };
  icraDaireleri: Array<MahkemeBirimleriRow> = [];

  headers = [
    {text: "Birim Adı", value: "birimAdi"},
    {text: "Dosya Esas No", value: "dosyaNo"},
    {text: "Açılış Tarihi", value: "dosyaAcilisTarihi"},
    {text: "Dosya Durumu", value: "dosyaDurum"}
  ];

  get isShowSuccessCloseButton() {
    return this.showSuccessCloseButton || this.showSuccessCloseButton === "";
  }

  get isHideNextButton() {
    return this.hideNextButton || this.hideNextButton === "";
  }

  get takipSorguTakipSecCardBind(): Record<string, unknown> {
    if (!this.showSecilenTakiplerExcelExport) {
      return {};
    }
    return {
      outlined: true,
      class: {
        'takip-sorgu-data-card': true,
        'takip-sorgu-data-card--error': this.takipSecilmediError
      }
    };
  }

  get takipSorguTakipSecTableStyle(): string | undefined {
    if (this.showSecilenTakiplerExcelExport) {
      return undefined;
    }
    return this.takipSecilmediError
        ? 'border: #ff5252 solid 1px; padding:20px'
        : 'border: #e0e0e0 solid 1px; padding:20px';
  }

  get takipSorguSecilenListeCardBind(): Record<string, unknown> {
    if (!this.showSecilenTakiplerExcelExport) {
      return {};
    }
    return {
      outlined: true,
      class: 'takip-sorgu-data-card mt-4'
    };
  }

  get takipSorguSecilenListeTableStyle(): string | undefined {
    if (this.showSecilenTakiplerExcelExport) {
      return undefined;
    }
    return 'border: #e0e0e0 solid 1px; padding:20px';
  }

  get filtrelenmisTabloVerisi() {
    const filtered = this.filtreleDosyalari();

    // Orijinal sıraya göre sırala
    return filtered.sort((a: any, b: any) => {
      // Önce rowOrder'a bak (Excel'den geliyorsa)
      if (a.rowOrder !== undefined && b.rowOrder !== undefined) {
        return a.rowOrder - b.rowOrder;
      }
      // Sonra originalIndex'e bak
      if (a.originalIndex !== undefined && b.originalIndex !== undefined) {
        return a.originalIndex - b.originalIndex;
      }
      // Son olarak index'e bak
      return (a.index || 0) - (b.index || 0);
    });
  }

  @Watch('localValue.secilen_takipler')
  onSecilenTakiplerChange() {
    this.takipSecilmediError = false;
  }

  // mounted olması lazım nedeni araştıralacak
  async created() {
    await this.getIcraDaireleri();
  }

  async getIcraDaireleri() {
    try {
      const response = await this.$uyap.MahkemeBirimleri().run({
        yargiTuru: this.localValue.filtre.yargiTuru,
        yargiBirimi: this.localValue.filtre.yargiBirimi,
        dosyaKapaliMi: (this.localValue.filtre.dosyaKapaliMi == 0) ? false : true
      })
      this.icraDaireleri = response.items;
    } catch (error) {
      console.error('İcra daireleri yüklenirken hata oluştu:', error);
    }
  }

  async getTakipler() {
    this.localValue.takipler = [];
    this.$nextTick(async () => {
      try {
        this.uyapTakipLoadStatus.loading = true;
        this.localValue.secilen_takipler = [];

        if (this.localValue.excel)
          await this.handleExcelUpload();
        else
          await this.handleUyapQuery();
      } catch (error) {
        this.handleGetTakiplerError(error);
      } finally {
        this.uyapTakipLoadStatus.loading = false;
      }
    });
  }

  async handleExcelUpload() {
    const excelFile = this.localValue.excel;
    const reader = new FileReader();
    reader.onload = (e: any) => {
      try {
        const excelData = this.parseExcelFile(e.target.result);
        this.validateExcelData(excelData);
        this.localValue.takipler = excelData;
      } catch (error) {
        this.handleGetTakiplerError(error);
      }
    };
    reader.readAsBinaryString(excelFile);
  }

  // Excel dosyasını parse et
  parseExcelFile(data: any): any[] {
    const workbook = XLSX.read(data, {type: 'binary'});
    const first_sheet_name = workbook.SheetNames[0];
    const worksheet = workbook.Sheets[first_sheet_name];
    const excelData: any = XLSX.utils.sheet_to_json(worksheet, {raw: true, blankrows: false});

    // Orijinal sırayı korumak için index alanları ekle
    excelData.forEach((takip: any, index: number) => {
      takip.index = index;
      takip.rowOrder = index;
      takip.originalIndex = index;

      if (!takip.birimId && takip.birimAdi) {
        takip.birimId = this.getBirimIdFromAdi(takip.birimAdi);
      }
    });

    // Orijinal sıraya göre sırala
    excelData.sort((a: any, b: any) => a.rowOrder - b.rowOrder);

    return excelData;
  }

  // Excel verilerini doğrula
  validateExcelData(excelData: any[]) {
    if (excelData[0] && !(excelData[0].birimAdi && excelData[0].dosyaNo)) {
      throw new Error("Excel başlıkları birimAdi ve dosyaNo olmalıdır.");
    }

    const hataliSatirlar: Array<number> = [];
    excelData.forEach((ed: any) => {
      ed.dosyaNo = ed.dosyaNo?.trim();
      ed.birimAdi = ed.birimAdi?.trim();
      if (!ed.dosyaNo.match(/^\d{4}\/\d+(?:\s*-\s*\(\s*\d{4}\/\d+\s*\))?$/)) {
        hataliSatirlar.push(ed.rowOrder + 2);
      }
    });

    if (hataliSatirlar.length > 0) {
      let hataMesaji = "Bir veya birden fazla dosya numarası hatalı görünüyor. Lütfen tüm dosya numaralarının dosyaNo sütununda yer aldığını kontrol edip tekrar deneyin.";
      if (hataliSatirlar.length != excelData.length) {
        hataMesaji += " Hatalı satırlar: " + hataliSatirlar.join(", ");
      }
      throw new Error(hataMesaji);
    }
  }

  // UYAP sorgusu - tüm UYAP mantığı burada
  async handleUyapQuery() {
    const talep = this.buildUyapRequest();
    const takipler = await this.executeUyapQuery(talep);
    this.processTakipler(takipler);
  }

  // UYAP talep objesi oluştur
  buildUyapRequest(): AvukatIcraDosyalariTalep {
    const talep = new AvukatIcraDosyalariTalep();
    talep.dosyaDurumKod = this.localValue.filtre.dosyaKapaliMi;

    // Listeleme türüne göre talep parametrelerini ayarla
    this.applyListelemeTuruToRequest(talep);

    // Detaylı aramadan tarih aralığı varsa ekle
    this.applyDetailedSearchDates(talep);

    return talep;
  }

  // Listeleme türüne göre talep parametrelerini ayarla
  applyListelemeTuruToRequest(talep: AvukatIcraDosyalariTalep) {
    const listeleme_turu = this.localValue.filtre.listeleme_turu;

    if (listeleme_turu === ListelemeTuru.KISI_ILE_ARAMA) {
      talep.setKisi(
          this.localValue.filtre.adi,
          this.localValue.filtre.soyadi,
          this.localValue.filtre.tcKimlikNo
      );
    } else if (listeleme_turu === ListelemeTuru.KURUM_ILE_ARAMA) {
      talep.setKurum(
          this.localValue.filtre.kurumAdi,
          this.localValue.filtre.mersisNo,
          this.localValue.filtre.vergiNo
      );
    } else if (listeleme_turu === ListelemeTuru.ACILIS_TARIH_ARALIGI) {
      talep.setAcilisTarihAraligi(
          this.localValue.filtre.baslangicTarihi,
          this.localValue.filtre.bitisTarihi
      );
    } else if (listeleme_turu === ListelemeTuru.KAPANIS_TARIH_ARALIGI) {
      talep.setKapanisTarihAraligi(
          this.localValue.filtre.baslangicTarihi,
          this.localValue.filtre.bitisTarihi
      );
    } else if (listeleme_turu === ListelemeTuru.SON_1_GUN) {
      this.setDateRangeForLastDays(talep, 1);
    } else if (listeleme_turu === ListelemeTuru.SON_1_HAFTA) {
      this.setDateRangeForLastDays(talep, 7);
    } else if (listeleme_turu === ListelemeTuru.SON_2_HAFTA) {
      this.setDateRangeForLastDays(talep, 14);
    } else if (listeleme_turu === ListelemeTuru.SON_1_AY) {
      this.setDateRangeForLastMonths(talep, 1);
    }
  }

  // Son X gün için tarih aralığı ayarla
  setDateRangeForLastDays(talep: AvukatIcraDosyalariTalep, days: number) {
    const baslangicTarihi = new Date();
    baslangicTarihi.setDate(baslangicTarihi.getDate() - days);
    talep.setAcilisTarihAraligi(baslangicTarihi.toISOString(), new Date().toISOString());
  }

  // Son X ay için tarih aralığı ayarla
  setDateRangeForLastMonths(talep: AvukatIcraDosyalariTalep, months: number) {
    const baslangicTarihi = new Date();
    baslangicTarihi.setMonth(baslangicTarihi.getMonth() - months);
    talep.setAcilisTarihAraligi(baslangicTarihi.toISOString(), new Date().toISOString());
  }

  // Detaylı aramadan tarih aralığı varsa ekle
  applyDetailedSearchDates(talep: AvukatIcraDosyalariTalep) {
    const hasDateRange = this.localValue.filtre.baslangicTarihi || this.localValue.filtre.bitisTarihi;
    const isDateBasedSearch = [
      ListelemeTuru.ACILIS_TARIH_ARALIGI,
      ListelemeTuru.KAPANIS_TARIH_ARALIGI,
      ListelemeTuru.SON_1_GUN,
      ListelemeTuru.SON_1_HAFTA,
      ListelemeTuru.SON_2_HAFTA,
      ListelemeTuru.SON_1_AY
    ].includes(this.localValue.filtre.listeleme_turu);

    if (hasDateRange && !isDateBasedSearch) {
      talep.setAcilisTarihAraligi(
          this.localValue.filtre.baslangicTarihi,
          this.localValue.filtre.bitisTarihi
      );
    }
  }

  // UYAP sorgusunu çalıştır
  async executeUyapQuery(talep: AvukatIcraDosyalariTalep): Promise<any> {
    const listeleme_turu = this.localValue.filtre.listeleme_turu;

    if (listeleme_turu === ListelemeTuru.ESAS_NO_ARALIGI) {
      return await this.queryByEsasNoAraligi(talep);
    } else if (listeleme_turu === ListelemeTuru.ICRAPRO_DOSYALARI) {
      return await this.queryFromIcraProAPI();
    } else {
      return await this.$uyap.AvukatIcraDosyalari().recursive(talep);
    }
  }

  // Esas no aralığı ile sorgula
  async queryByEsasNoAraligi(talep: AvukatIcraDosyalariTalep): Promise<any> {
    const dosyaYil = this.localValue.filtre.dosyaYil || 0;
    const dosyaSira = Number(this.localValue.filtre.dosyaSira) || 0;
    const dosyaSira2 = this.localValue.filtre.dosyaSira2 ? Number(this.localValue.filtre.dosyaSira2) : null;

    // Min/Max kontrolü - UYAP'a doğru sırayla gönder
    let minSira = dosyaSira;
    let maxSira = dosyaSira2;

    if (dosyaSira2) {
      minSira = Math.min(dosyaSira, dosyaSira2);
      maxSira = Math.max(dosyaSira, dosyaSira2);
    }

    return await this.$uyap.AvukatIcraDosyalari().esasNoAraligi(talep, dosyaYil, minSira, maxSira);
  }

  // İcraPRO API'den sorgula
  async queryFromIcraProAPI(): Promise<any> {
    const takiplerRes = await this.$http.get('/api/v1/uyap-dosya-listele');
    const takipler = {items: []};

    takiplerRes.data.forEach((takip: {
      id: number,
      icra_dairesi_id: number,
      dosya_esas_no: string,
      uyap_dosya_id: string,
      icra_dairesi: IcraDairesiEntity
    }) => {
      takipler.items.push({
        birimAdi: takip.icra_dairesi?.isim,
        dosyaNo: takip.dosya_esas_no,
        dosyaId: takip.uyap_dosya_id,
        birimId: takip.icra_dairesi_id.toString()
      });
    });

    return takipler;
  }

  // Takipleri işle ve kaydet
  processTakipler(takipler: any) {
    if (takipler && Array.isArray(takipler.items)) {
      // Takiplere index ekle ve birimId kontrolü yap
      takipler.items.forEach((takip: any, index: number) => {
        takip.index = index;

        // birimId ve birimAdi arasında ilişki kur
        if (!takip.birimId && takip.birimAdi) {
          takip.birimId = this.getBirimIdFromAdi(takip.birimAdi);
        }
      });
      this.localValue.takipler = takipler.items;
    } else {
      console.error("Takipler alınamadı veya geçersiz formatta:", takipler);
      this.uyapTakipLoadStatus.error = true;
      this.uyapTakipLoadStatus.errorMessage = "Takipler alınamadı veya boş döndü";
      this.localValue.takipler = [];
    }
  }

  // Hata yönetimi
  handleGetTakiplerError(error: any) {
    const err = error as any;
    this.uyapTakipLoadStatus.errorMessage = err.message;
    this.uyapTakipLoadStatus.error = true;
    console.error("Takipler alınırken hata:", err.message);
  }

  getBirimIdFromAdi(birimAdi: string): string {
    const daire = this.icraDaireleri.find(d => d.birimAdi === birimAdi);
    if (daire)
      return daire.birimId.toString();
    return "";
  }

  private takiplerdenExcelSatirlari(items: IAvukatDosya[]): Array<Record<string, string>> {
    return items.map((item: IAvukatDosya) => ({
      'Birim Adı': item.birimAdi ?? '',
      'Dosya Esas No': item.dosyaNo ?? '',
      'Açılış Tarihi': item.dosyaAcilisTarihi
          ? this.$uyapHelper.tarihLocaleStr(item.dosyaAcilisTarihi)
          : '',
      'Dosya Durumu': item.dosyaDurum ?? ''
    }));
  }

  private takipleriXlsxYaz(
      items: IAvukatDosya[],
      sheetAdi: string,
      dosyaAdi: string
  ): void {
    if (items.length === 0) {
      return;
    }
    const worksheet = XLSX.utils.json_to_sheet(this.takiplerdenExcelSatirlari(items));
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, sheetAdi);
    XLSX.writeFile(workbook, dosyaAdi);
  }

  indirTabloTakipleriExcel(): void {
    const tarih = new Date().toISOString().slice(0, 10);
    this.takipleriXlsxYaz(
        this.filtrelenmisTabloVerisi as IAvukatDosya[],
        'Takipler',
        `takipler-listesi_${tarih}.xlsx`
    );
  }

  indirSecilenTakiplerExcel(): void {
    const tarih = new Date().toISOString().slice(0, 10);
    this.takipleriXlsxYaz(
        this.localValue.secilen_takipler,
        'SecilenTakipler',
        `secilen-takipler_${tarih}.xlsx`
    );
  }

  selectAll() {
    // Filtrelenmiş veri ile çalışmalı, tüm takiplerle değil
    const filtrelenmisVeri = this.filtrelenmisTabloVerisi;

    if (this.localValue.secilen_takipler.length == filtrelenmisVeri.length) {
      this.localValue.secilen_takipler = []
    } else {
      // Seçilen takipleri de orijinal sıraya göre sırala
      const secilenTakipler = [...filtrelenmisVeri];
      secilenTakipler.sort((a: any, b: any) => {
        if (a.rowOrder !== undefined && b.rowOrder !== undefined) {
          return a.rowOrder - b.rowOrder;
        }
        if (a.originalIndex !== undefined && b.originalIndex !== undefined) {
          return a.originalIndex - b.originalIndex;
        }
        return (a.index || 0) - (b.index || 0);
      });

      this.localValue.secilen_takipler = secilenTakipler;
    }
    this.input();
  }

  success() {
    this.activeStep = 1;
    this.localValue.secilen_takipler = [];
    this.$emit('onSuccess');
  }

  nextStep() {
    if (this.activeStep == 1) {
      this.getTakipler();
      this.activeStep++;
    } else if (this.activeStep == 2) {
      if (this.localValue.secilen_takipler.length == 0) this.takipSecilmediError = true;
      else this.activeStep++;
    } else if (this.activeStep < this.stepperHeaders.length) {
      this.activeStep++;
    }
    if (this.activeStep >= this.stepperHeaders.length) {
      this.$emit('final');
    }
    this.$emit('step', this.activeStep);
    this.focusStep(this.activeStep);
  }

  previousStep() {
    if (this.activeStep > 1) {
      this.activeStep--;
      this.uyapTakipLoadStatus = {
        loading: false,
        error: false,
        errorMessage: ''
      };
    }
    this.$emit('step', this.activeStep);
    this.focusStep(this.activeStep);
  }

  islemlereGit() {
    this.$router.push(ProgramPaths.eicrapro + '/islemler');
  }

  sifirla() {
    this.localValue = new GenelIslemEntity();
    this.input();
    this.activeStep = 1;
  }

  focusStep(step: any) {
    let activeHeader = (this.$refs['step' + step] as Vue[])[0].$el;
    let headers = this.$refs['headers'] as Element;
    let activeHeaderRight = activeHeader.getBoundingClientRect().right;
    let headersLeft = headers.getBoundingClientRect().left;
    let headersWidth = headers.getBoundingClientRect().width;
    let scrollPosition = (activeHeaderRight - headersLeft) - headersWidth;
    if (scrollPosition < 0) {
      scrollPosition = 0;
    }
    headers.scrollLeft += scrollPosition;
  }

  filtreleDosyalari() {
    // Veri doğrulama
    if (!this.isValidTakipData()) {
      return [];
    }

    // Orijinal takipleri kopyala
    let filtreliTakipler = JSON.parse(JSON.stringify(this.localValue.takipler));

    // Filtreleri sırayla uygula
    filtreliTakipler = this.applyIcraDairesiFiltresi(filtreliTakipler);
    filtreliTakipler = this.applyDosyaYiliFiltresi(filtreliTakipler);
    filtreliTakipler = this.applyDosyaSiraFiltresi(filtreliTakipler);
    filtreliTakipler = this.applyTarihFiltresi(filtreliTakipler);

    // Orijinal sıraya göre sırala
    return this.sortByOriginalOrder(filtreliTakipler);
  }

  // Veri doğrulama
  isValidTakipData(): boolean {
    if (!this.localValue.takipler || !Array.isArray(this.localValue.takipler)) {
      return false;
    }
    if (this.localValue.takipler.length === 0) {
      return false;
    }
    return true;
  }

  // İcra dairesi filtresi
  applyIcraDairesiFiltresi(takipler: any[]): any[] {
    if (!this.localValue.filtre.secilenIcraDairesi) {
      return takipler;
    }

    const secilenId = this.localValue.filtre.secilenIcraDairesi.toString();

    const oncekiSayi = takipler.length;

    const filtrelenmis = takipler.filter((takip: any) => {
      if (!takip || !takip.birimId) return false;
      const takipBirimId = String(takip.birimId);
      return takipBirimId === secilenId;
    });

    return filtrelenmis;
  }

  // Dosya yılı filtresi
  applyDosyaYiliFiltresi(takipler: any[]): any[] {
    if (!this.localValue.filtre.dosyaYil) {
      return takipler;
    }

    const dosyaYilStr = String(this.localValue.filtre.dosyaYil);
    const oncekiSayi = takipler.length;

    const filtrelenmis = takipler.filter((takip: any) => {
      if (!takip || !takip.dosyaNo) return false;

      const dosyaNo = takip.dosyaNo;

      // Format: YIL/SIRA
      if (dosyaNo.includes('/')) {
        const yil = dosyaNo.split('/')[0];
        return yil === dosyaYilStr;
      }
      return false;
    });

    return filtrelenmis;
  }

// Dosya sıra numarası filtresi
  applyDosyaSiraFiltresi(takipler: any[]): any[] {
    if (!this.localValue.filtre.dosyaSira) {
      return takipler;
    }

    const dosyaSira1Str = String(this.localValue.filtre.dosyaSira);
    const dosyaSira2 = this.localValue.filtre.dosyaSira2
        ? Number(this.localValue.filtre.dosyaSira2)
        : null;

    const dosyaSira1Num = Number(this.localValue.filtre.dosyaSira);

    return takipler.filter((takip: any) => {
      if (!takip?.dosyaNo || !takip.dosyaNo.includes('/')) return false;

      const parcalar = takip.dosyaNo.split('/');
      if (parcalar.length < 2) return false;

      const siraStr = parcalar[1];
      const siraNum = Number(siraStr);

      // 2 değer girilmişse → sayısal aralık
      if (dosyaSira2 !== null && !isNaN(siraNum)) {
        const min = Math.min(dosyaSira1Num, dosyaSira2);
        const max = Math.max(dosyaSira1Num, dosyaSira2);
        return siraNum >= min && siraNum <= max;
      }

      // 1 değer girilmişse → içerir (string include)
      return siraStr.includes(dosyaSira1Str);
    });
  }

// Tarih filtresi
  applyTarihFiltresi(takipler: any[]): any[] {
    if (!this.localValue.filtre.baslangicTarihi && !this.localValue.filtre.bitisTarihi) {
      return takipler;
    }

    const oncekiSayi = takipler.length;
    const baslangicTarihiVar = !!this.localValue.filtre.baslangicTarihi;
    const bitisTarihiVar = !!this.localValue.filtre.bitisTarihi;

    // Tarih değerlerini hazırla
    let baslangicTarihi: Date | undefined;
    let bitisTarihi: Date | undefined;

    if (baslangicTarihiVar) {
      baslangicTarihi = new Date(this.localValue.filtre.baslangicTarihi);
      baslangicTarihi.setHours(0, 0, 0, 0);
    }

    if (bitisTarihiVar) {
      bitisTarihi = new Date(this.localValue.filtre.bitisTarihi);
      bitisTarihi.setHours(23, 59, 59, 999);
    }

    const filtrelenmis = takipler.filter((takip: any) => {
      if (!takip || !takip.dosyaAcilisTarihi) return false;

      try {
        const dosyaTarihi = this.parseDosyaTarihi(takip.dosyaAcilisTarihi);

        // Geçerli tarih kontrolü
        if (isNaN(dosyaTarihi.getTime())) {
          return false;
        }

        // Tarih aralığı kontrolü
        let gecerli = true;

        if (baslangicTarihiVar && baslangicTarihi) {
          gecerli = gecerli && dosyaTarihi >= baslangicTarihi;
        }

        if (bitisTarihiVar && bitisTarihi) {
          gecerli = gecerli && dosyaTarihi <= bitisTarihi;
        }

        return gecerli;
      } catch (error) {
        return false;
      }
    });

    return filtrelenmis;
  }

  // Tarih parse etme - yardımcı metod
  parseDosyaTarihi(tarih: any): Date {
    // Yapılandırılmış tarih formatı (mock data formatı)
    if (tarih.date && tarih.time) {
      const dateObj = tarih.date;
      const timeObj = tarih.time;

      return new Date(
          dateObj.year,
          dateObj.month - 1, // JavaScript'te aylar 0'dan başlar
          dateObj.day,
          timeObj.hour || 0,
          timeObj.minute || 0,
          timeObj.second || 0,
          (timeObj.nano || 0) / 1000000 // nano'yu milisaniyeye çevir
      );
    } else if (typeof tarih === 'string') {
      // String tarih formatı
      return new Date(tarih);
    } else if (tarih instanceof Date) {
      // Zaten Date objesi
      return tarih;
    } else {
      // Diğer durumlar için toString() kullan
      return new Date(tarih.toString());
    }
  }

  // Orijinal sıraya göre sırala
  sortByOriginalOrder(takipler: any[]): any[] {
    const sorted = takipler.sort((a: any, b: any) => {
      // Önce rowOrder'a bak (Excel'den geliyorsa)
      if (a.rowOrder !== undefined && b.rowOrder !== undefined) {
        return a.rowOrder - b.rowOrder;
      }
      // Sonra originalIndex'e bak
      if (a.originalIndex !== undefined && b.originalIndex !== undefined) {
        return a.originalIndex - b.originalIndex;
      }
      // Son olarak index'e bak
      return (a.index || 0) - (b.index || 0);
    });

    return sorted;
  }
}

export class GenelIslemEntity {
  filtre: TakipFiltreEntity = new TakipFiltreEntity();
  excel!: File;
  takipler: Array<IAvukatDosya> = [];
  secilen_takipler: Array<IAvukatDosya> = [];
}

class TakipFiltreEntity {
  dosyaKapaliMi: 0 | 1 = 0;
  yargiTuru: number = 2;
  yargiBirimi: any = '1101';
  mahkeme: string = "";
  listeleme_turu: any = 1;
  dosyaYil: number | undefined;
  dosyaSira: number | undefined;
  dosyaSira2!: number | undefined;
  baslangicTarihi: string = "";
  bitisTarihi: string = "";
  dosyaKapanisBaslangisTarihi: string = "";
  dosyaKapanisBitisTarihi: string = "";
  tcKimlikNo: string = '';
  adi: string = '';
  soyadi: string = '';
  kurumAdi: string = '';
  mersisNo: string = '';
  vergiNo: string = '';
  secilenIcraDairesi: number | undefined;
}
